module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userStatus && _vm.wizardStep !== 'done') ? _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "wizard clearfix",
    attrs: {
      "role": "application",
      "id": "steps-uid-0"
    }
  }, [_c('div', {
    staticClass: "steps clearfix"
  }, [_c('ul', {
    staticClass: "onboarding",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "first",
    class: {
      disabled: _vm.wizardStep !== 'personalInformation', current: _vm.wizardStep === 'personalInformation'
    },
    attrs: {
      "role": "tab",
      "aria-disabled": "false",
      "aria-selected": "true"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.wizardStep !== 'addFundingSource', current: _vm.wizardStep === 'addFundingSource'
    },
    attrs: {
      "role": "tab",
      "aria-disabled": "true"
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('li', {
    staticClass: "last",
    class: {
      disabled: _vm.wizardStep !== 'firstInvestment', current: _vm.wizardStep === 'firstInvestment'
    },
    attrs: {
      "role": "tab",
      "aria-disabled": "true"
    }
  }, [_vm._m(2)])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "steps-uid-0-t-0",
      "aria-controls": "steps-uid-0-p-0"
    }
  }, [_c('span', {
    staticClass: "current-info audible"
  }, [_vm._v("current step: ")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Personal information\n            "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Add your personal information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "steps-uid-0-t-1",
      "aria-controls": "steps-uid-0-p-1"
    }
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2.")]), _vm._v(" Bank account\n            "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Add a bank account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "steps-uid-0-t-2",
      "aria-controls": "steps-uid-0-p-2"
    }
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3.")]), _vm._v(" Investments\n            "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Make your first investment")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c666570","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnboardingWizard.vue
// module id = 2102
// module chunks = 1